import React from 'react'

import {MentionOption} from "../../option"
import TaskTypeIcon from "../../../../../icons/task-icon/task-icon-ui5"
import UserIcon from "../../../../../../gd-ui/icon/user/user"
import ProjectIconUI5 from "../../../../../../gd-ui/project-icon/project-icon-ui5"
import {EntityType} from "../../../../../../gd/const/item"
import getDocumentIcon from "../../../../../icons/document/functions/get-document-icon"

type Props = {
    mention     : MentionOption
}

export default function Mention(props: Props): JSX.Element {
    let res = <span/>

    switch (props.mention.type) {
        case EntityType.TASK       :
            const task = props.mention.data
            res = (
                <div className="mention-item">
                    <TaskTypeIcon className="mention-icon m-r-5" icon={task.icon}/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{task.title}</div>
                </div>
            )
            break

        case EntityType.DOCUMENT   :
            const note = props.mention.data
            const icon = getDocumentIcon(note.noteTypeId)
            res = (
                <div className="mention-item">
                    <div className={Classes("mention-icon ui5-ico-13 m-r-5", icon)}/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{note.name}</div>
                </div>
            )
            break

        case EntityType.USER       :
            res = (
                <div className="mention-item user-mention">
                    <UserIcon className="m-r-5" userId={props.mention.id} hint={false} size="22"/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{props.mention.name}</div>
                </div>
            )
            break

        case EntityType.PROJECT:
            res = (
                <div className="mention-item">
                    <ProjectIconUI5 className="mention-icon m-r-5" size="13" projectId={props.mention.id} colorize={false}/>
                    <div className="ui5-txt-default-small max-w-200 txt-truncate">{props.mention.name}</div>
                </div>
            )
            break
    }

    return res
}
